import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import "./mobile.css";

import HeroSection from "./HeroSection";

const SolutionSection = lazy(() => import("./SolutionSection"));
const BenefitSection = lazy(() => import("./BenefitSection"));
const FeatureSection = lazy(() => import("./FeatureSection"));

const MobileAppDevelopment = () => {
  return (
    <>
      <Helmet>
        <title>
          Mobile App Development | iOS, Android & Cross-Platform by Lentera
        </title>
        <meta
          name="description"
          content="Lentera Technologies develops custom mobile apps for iOS, Android, and cross-platform frameworks, delivering scalable, engaging, and user-focused solutions."
        />
        <meta
          name="keywords"
          content="Custom mobile apps, iOS app development, Android app development, cross-platform apps, React Native, Flutter, enterprise mobile solutions, user experience apps.Custom mobile apps, iOS app development, Android app development, cross-platform apps, React Native, Flutter, enterprise mobile solutions, user experience apps."
        />
      </Helmet>

      <HeroSection />

      <Suspense fallback={<div className="h-[400px]" />}>
        <SolutionSection />
        <BenefitSection />
        <FeatureSection />
      </Suspense>
    </>
  );
};

export default MobileAppDevelopment;
